module.exports = __webpack_public_path__ + "static/img/design-5.d5609df3.png";